import { useState } from "react";
import { Box, Button, CssBaseline, Typography } from "@mui/material";
import MetaDecorator from "../../services/meta_decorator";
import { Redirect, } from "react-router-dom";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { bodyBg, fullHeight, orangecolor, pcolor, registrationHeader, whitecolor } from "../../style2";


export default function ReferralApps() {
    const [redirect, setRedirect] = useState('');

    if (redirect !== "")
        return <Redirect to={redirect} />;
    else
        return <Box sx={{...bodyBg, ...fullHeight}}>
            <CssBaseline />
            <MetaDecorator title={"EnrichMyCare - Referral"} description={"EnrichMycare Refferal"} />
            <Box style={{ paddingTop: "100px" }}>
                <Box style={{ background: whitecolor, padding: 10, height: "450px", width: "800px", margin: "0 auto", borderRadius: "20px" }}>
                    <Box style={{ textAlign: "center", paddingBottom: "40px", paddingTop: "30px" }}>
                        <img style={{ maxHeight: 100 }} src='../derbyshireNHSTrust.png' alt='Derbyshire Healthcare NHS Foundation Trust' />
                    </Box>
                    <Box style={{ textAlign: "center", paddingBottom: "20px", paddingTop:"20px" }}>
                        <Button onClick={() => { setRedirect(`/referral/dhcft-01`) }}
                            sx={{ padding: "0 30px", background: orangecolor, borderRadius: 15, color: whitecolor, textTransform: "capitalize", fontSize: "1.3rem", height: "50px" }}><span style={{ marginRight: "10px" }}>Patient Referral</span> <ArrowForwardIcon /></Button>
                    </Box>
                    <Box style={{ paddingTop: 30, paddingBottom: 10, textAlign: "center" }}>
                        <Typography sx={{ color: pcolor }}>Powered by</Typography>
                        <Box component="img"
                         sx={registrationHeader} src='../Logo_Option_1.svg' alt='logo' />
                    </Box>
                </Box>
            </Box>
        </Box>;
}